import Header from "@/reusable_sections/Header";
import ContactInformation from "./sections/ContactInformation";
import ContactForm from "./sections/ContactForm";
import SignUpForm from "./sections/SignUpForm";
import Footer from "@/reusable_sections/Footer";
export default function ContactSignUpPage() {
  return <div>
      <Header />
      <ContactInformation />
      <ContactForm />
      <SignUpForm />
      <Footer />
    </div>;
}